<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  value: string | null
  lost?: boolean
}>()

const rank = computed(() => (props.value ? props.value[0] : null))
const suit = computed(() => (props.value ? props.value[1].toLowerCase() : null))
</script>
<template>
  <div
    :class="{
      'flex flex-col gap-px w-5 rounded-[3px] bg-white pl-[2px] font-DINCondensed': true,
      [`small-card--${suit}`]: true
    }"
  >
    <div class="leading-none text-[17px] font-bold w-fit">{{ rank }}</div>
    <img class="w-[9px] h-[9px] ml-[1.5px]" v-if="suit === 'c'" src="@/assets/cards/club.png" />
    <img
      class="w-[9px] h-[9px] ml-[1.5px]"
      v-else-if="suit === 'h'"
      src="@/assets/cards/heart.png"
    />
    <img
      class="w-[9px] h-[9px] ml-[1.5px]"
      v-else-if="suit === 's'"
      src="@/assets/cards/spade.png"
    />
    <img
      class="w-[9px] h-[9px] ml-[1.5px]"
      v-else-if="suit === 'd'"
      src="@/assets/cards/diamond.png"
    />
  </div>
</template>

<style lang="scss" scoped>
.small-card{
  &--c {
    color: #21252d;
  }

  &--s {
    color: #21252d;
  }

  &--h {
    color: #cc3933;
  }

  &--d {
    color: #cc3933;
  }
}
</style>
